import { Box } from "@chakra-ui/react";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectColorThemeMode } from "stores/ui/uiSlice";

const AuthDisplayArea = ({ children }) => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  return (
    <Box
      h={"100%"}
      w="full"
      bg={`${colorThemeMode}_tertiary`}
      color={`${colorThemeMode}_text`}
    >
      {children}
    </Box>
  );
};

export default AuthDisplayArea;
